/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PureComponent } from 'react';

import { TextInput } from '../../../uiold';
import FormField from '../helpers/FormField';
import GooglePlacesAutocomplete, {
  Place,
} from '../../../GooglePlacesAutocomplete';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
  readOnly?: boolean;
  onChange?: (id: string, value: string) => void;
};

type State = {
  inputValue: string;
  selectedPlace: Place | null | undefined;
};

class LocationInputElementFormView extends PureComponent<Props, State> {
  state: State = {
    inputValue: '',
    selectedPlace: null,
  };

  render() {
    let { props } = this;
    return <FormField {...props}>{this._renderField()}</FormField>;
  }

  _renderField = () => {
    let { definition, readOnly } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'LocationInput') {
      return null;
    }
    if (readOnly) {
      return (
        <TextInput
          tabIndex={-1}
          placeholder={definition.placeholder || ''}
          value={this.state.inputValue}
        />
      );
    }
    return (
      <GooglePlacesAutocomplete
        placeholder={definition.placeholder ?? undefined}
        onChange={(event: any) =>
          this.setState({ inputValue: event.target.value })
        }
        onPlaceSelect={this._onPlaceSelect}
        onBlur={this._validatePlace}
        value={this.state.inputValue}
      />
    );
  };

  _onPlaceSelect = (place: Place) => {
    this.setState({
      inputValue: place.textName,
      selectedPlace: place,
    });
    let { onChange, definition } = this.props;
    if (onChange != null) {
      onChange(definition.id, place.id);
    }
  };

  _validatePlace = () => {
    if (this.state.inputValue === '') {
      this.setState({
        selectedPlace: null,
      });
    } else {
      let { textName } = this.state.selectedPlace || {};
      this.setState({
        inputValue: textName || '',
      });
    }
  };

  setValue = () => {
    // not supported
  };

  getValue = () => {
    return this.state.selectedPlace;
  };
}

export default LocationInputElementFormView;
